export default __webpack_public_path__ + "static/media/Strangler's Boots of the Battlethrall.d3c93832.jpg";